import gql from 'graphql-tag';

export default gql`
  mutation adminSendPrincipalEmail ($input: AdminSendPrincipalEmailInput!) {
    adminSendPrincipalEmail(input: $input)
  }
`;
